import { useState } from "react";

const navLinks: { id: number; label: string; href: string }[] = [
  { id: 1, label: "最新速递", href: "#feed" },
  { id: 2, label: "热门实锤", href: "#featured" },
  { id: 3, label: "事件时间线", href: "#timeline" },
  { id: 4, label: "讨论热度", href: "#ranking" },
  { id: 5, label: "达人名录", href: "#directory" },
  { id: 6, label: "社区讨论", href: "#community" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg"></i>
          </span>
          <h1 className="font-heading text-xl font-black tracking-tight text-foreground-950">黑料国产</h1>
          <span className="hidden rounded-full border border-background-300 px-2 py-0.5 text-[11px] text-secondary-600 sm:inline-block">
            事件档案站
          </span>
        </a>

        <nav className="ml-4 hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          <label className="hidden items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2 text-sm text-foreground-400 xl:flex">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line"></i>
            </span>
            <input
              type="text"
              placeholder="搜主播 / 事件关键词"
              className="w-40 bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
          </label>
          <a
            href="#community"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-block"
          >
            上报黑料
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto grid max-w-[1400px] grid-cols-2 gap-2 px-4 py-4 md:px-6">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}